// reducer.js
import {
  SET_VALUE_PCGP,
  SET_TYPE_PCGP,
  SET_CURRENT_PAGE_PCGP,
  SET_ORDER_PCGP,
  SET_SORT_FIELD_PCGP,
  SET_ACTIF_PCGP,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "asc",
  sortField: "nom",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_PCGP:
      return {
        ...state,
        value: action.payload,
      };
    case SET_TYPE_PCGP:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_PCGP:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_PCGP:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_PCGP:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_PCGP:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
